export const GENDERS = [
    {value: 'Male', label: 'Male'},
    {value: 'Female', label: 'Female'},
    {value: 'Prefer no to say', label: 'Prefer not to say'}
];